import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TrueGrit} from "../TrueGrit";
import {TimelineMax} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayUtils} from "../utils/ArrayUtils";
import {TrueGritStatics} from "../TrueGritStatics";
import {SimpleReelModelEventData, SimpleReelModelState} from "../../core/reel/ReelInterfaces";
import {TrueGritModel} from "../TrueGritModel";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TrueGritNormalResultPresentation implements FlowStatePresentation {
    protected _tl:TimelineMax;
    protected _topReelStopTl:TimelineMax;
    protected _botReelStopTl:TimelineMax;
    protected _stoppedReels:boolean[];

    public start(flowStateController:FlowStateController) {
        this._stoppedReels = [false, false, false, false, false, false, false, false];
        let luckyDrawDuration:number = 0;

        TrueGritModel.previousReelsAfterCollapse = JSON.parse(JSON.stringify(TrueGrit.model.data.reelsAfterCollapse));

        this._tl = new TimelineMax();

        // #416, #472
        this._tl.add(() => flowStateController.setSkipCallback(() => this.skip(flowStateController)), 0.1);

        if(TrueGrit.model.gameData.luckyDraw) {
            const luckyDrawTl: TimelineMax = TrueGrit.luckyDrawView.getLuckyDrawTL();
            luckyDrawDuration = luckyDrawTl.totalDuration() - 0.55;
            this._tl.add(luckyDrawTl);
        }

        const mainReelStopDelay = TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.mainReelAllInStopDelayFastSpin : TrueGritStatics.mainReelAllInStopDelay;
        const topReelDelay = TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.topReelAllInStopDelayFastSpin : TrueGritStatics.topReelAllInStopDelay;
        const bottomReelDelay = TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.bottomReelAllInStopDelayFastSpin : TrueGritStatics.bottomReelAllInStopDelay;

        this._topReelStopTl = new TimelineMax({delay : luckyDrawDuration});
        this._botReelStopTl = new TimelineMax({delay : luckyDrawDuration});
        //Top reel
        this._topReelStopTl.add([
            TrueGrit.allReelsView.topReelModel.stop(TrueGrit.model.gameData.topTrain.beforeSpellSymbols),
            () => TrueGrit.allReelsView.topReelModel.events?.once(SimpleReelModelState.STOPPED, (data:SimpleReelModelEventData) => this.onReelStop(data, flowStateController))
        ], topReelDelay);
        //Bottom reel
        if(TrueGrit.model.gameData.xSplits) {
            this._botReelStopTl.add(TrueGrit.allReelsView.bottomReelModel.stop(TrueGrit.model.reelSplitLongReel.slice(0, 4)), bottomReelDelay);
        } else {
            this._botReelStopTl.add(TrueGrit.allReelsView.bottomReelModel.stop(TrueGrit.model.gameData.botTrain.symbols), bottomReelDelay);
        }
        this._botReelStopTl.add(() => TrueGrit.allReelsView.bottomReelModel.events?.once(SimpleReelModelState.STOPPED, (data:SimpleReelModelEventData) => this.onReelStop(data, flowStateController)), bottomReelDelay);

        let stopTime: number = 0,
            nearWinDelay: number = 0,
            previousReelStopDurations: number[] = [0, 0, 0, 0, 0, 0];
        for(let i:number = 0; i < TrueGrit.model.gameData.reels.length; i++) {
            const reelStopAnimation:TimelineMax = new TimelineMax({delay : luckyDrawDuration});

            reelStopAnimation.add(TrueGrit.allReelsView.mainReelModels[i].stop(TrueGrit.model.gameData.reels[i]));
            previousReelStopDurations[i] = reelStopAnimation.totalDuration();
            if (TrueGrit.model.gritGirlNearWinReels[i - 1] || TrueGrit.model.scatterNearWinReels[i - 1]) {
                nearWinDelay = previousReelStopDurations[i - 1] - 0.2;
            } else {
                nearWinDelay = 0;
            }
            stopTime += nearWinDelay;

            TrueGrit.allReelsView.mainReelModels[i].events?.once(SimpleReelModelState.STOPPED, (data:SimpleReelModelEventData) => this.onReelStop(data, flowStateController));

            this._tl.add(reelStopAnimation, stopTime);
            stopTime += mainReelStopDelay;
        }

        const padding = TrueGrit.gameFlowController.calculatePaddingDuration(this._tl.totalDuration() - 0.1);
        if(padding > 0 && !TrueGrit.model.gameData.luckyDraw) {
            this._tl.shiftChildren(padding);
        }
    }

    protected onReelStop(data:SimpleReelModelEventData, flowStateController:FlowStateController) {
        this._stoppedReels[data.reel] = true;
        if(ArrayUtils.isAllTrue(this._stoppedReels)) {
            this.completePresentation(flowStateController);
        }
    }

    // #416
    protected skip(flowStateController: FlowStateController): void {
        // #472
        if (!TrueGrit.anticipationView.isAnticipating) {
            flowStateController.setSkipCallback(() => this.skip(flowStateController));
            return;
        }

        if (this._tl) {
            this._tl.timeScale(5);
        }
        if (this._topReelStopTl) {
            this._topReelStopTl.timeScale(5);
        }
        if (this._botReelStopTl) {
            this._botReelStopTl.timeScale(5);
        }
    }

    private completePresentation(flowStateController:FlowStateController) {
        TrueGrit.waysView.updateNumberOfWays();
        flowStateController.finish();
    }
}